import { render, staticRenderFns } from "./viewer-image.vue?vue&type=template&id=881406be&scoped=true"
import script from "./viewer-image.vue?vue&type=script&lang=js"
export * from "./viewer-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "881406be",
  null
  
)

export default component.exports